exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.landing-frame[data-v-4aa7bda0] {\n\tdisplay: flex;\n\talign-items: center;\n\tmin-height: 40vh;\n}\n.landing-text[data-v-4aa7bda0] {\n\tfont-size: 1em;\n\ttext-align: justify;\n\tfont-weight: bold;\n}\n.landing-middle[data-v-4aa7bda0] {\n\tdisplay: block;\n\tmargin: 0 auto;\n}\n\n\n", ""]);

// exports
